import { useParams } from 'react-router-dom';
import { useTable } from '../../hooks/useTableManagement';
import { useTableStatus } from '../../hooks/useTableCheckIn';
import { Card } from '../../components/ui/Card';
import type { CheckIn } from '@shared/types';
import './TableStatusPage.css';

export function TableStatusPage() {
  const { tableId } = useParams<{ tableId: string }>();

  const { data: table, isLoading: isLoadingTable } = useTable(tableId || '');
  const { data: status, isLoading: isLoadingStatus } = useTableStatus(tableId || '', 2000);

  if (isLoadingTable || isLoadingStatus) {
    return (
      <div className="table-status-page">
        <div className="table-status-page__loading">Carregando...</div>
      </div>
    );
  }

  if (!table) {
    return (
      <div className="table-status-page">
        <Card className="table-status-page__error-card">
          <h2>Mesa não encontrada</h2>
        </Card>
      </div>
    );
  }

  const waitingPlayers = status?.waitingPlayers || [];

  return (
    <div className="table-status-page">
      <Card className="table-status-page__card">
        <div className="table-status-page__header">
          <h1 className="table-status-page__title">{table.name}</h1>
          {table.location && (
            <p className="table-status-page__location">📍 {table.location}</p>
          )}
        </div>

        <div className="table-status-page__section">
          <h2 className="table-status-page__section-title">
            Jogadores Aguardando ({waitingPlayers.length})
          </h2>

          {waitingPlayers.length === 0 ? (
            <div className="table-status-page__empty">
              <p>Nenhum jogador aguardando no momento</p>
              <p className="table-status-page__empty-hint">
                Escaneie o QR code da mesa para fazer check-in
              </p>
            </div>
          ) : (
            <div className="table-status-page__players">
              {waitingPlayers.map((player: CheckIn) => (
                <div key={player.id} className="table-status-page__player-card">
                  <div className="table-status-page__player-info">
                    <span className="table-status-page__player-name">
                      {player.playerName}
                    </span>
                    <span className="table-status-page__player-game">
                      {player.gameType}
                    </span>
                  </div>
                  <span className="table-status-page__player-badge">
                    {player.qrCodeType === 'player1' ? 'Jogador 1' : 'Jogador 2'}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="table-status-page__qr-section">
          <h3 className="table-status-page__qr-title">QR Codes Disponíveis</h3>
          <div className="table-status-page__qr-codes">
            <div className="table-status-page__qr-code">
              <div className="table-status-page__qr-placeholder">QR</div>
              <span>Central</span>
            </div>
            <div className="table-status-page__qr-code">
              <div className="table-status-page__qr-placeholder">QR</div>
              <span>Jogador 1</span>
            </div>
            <div className="table-status-page__qr-code">
              <div className="table-status-page__qr-placeholder">QR</div>
              <span>Jogador 2</span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
